import type en from './en';

const fr: typeof en = {
  app: {
    loading: 'Chargement...',
    somethingWentWrong: 'Un problème est survenu',
    pageNotFound: 'Page introuvable',
    signInFailed: 'Échec de la connexion',
    close: 'Fermer',
  },
  welcome: {
    logoAlt: 'Weekly Squads',
    tagline:
      'Un jeu quotidien d’ouverture de packs où vous bâtissez votre équipe pour les matchs du week-end',
    cta: 'Se connecter ou s’inscrire',
  },
  nav: {
    locked: 'Verrouillé',
  },
  lobby: {
    prize: 'Prix :',
    monthlyPrize: 'Prix du mois :',
    totals: {
      tackles: 'Tacles',
      intercepts: 'Intercept.',
      shots: 'Tirs',
      goals: 'Buts',
      pts: 'Pts',
    },
    stats: 'Ta {{tackles}} • I {{interceptions}} • Ti {{shots}} • B {{goals}}',
    expiresIn: 'Expire dans {{time}}',
    revealIn: 'Ouvre dans {{time}}',
    drawing: 'Tirage de votre équipe…',
    enterError: 'Impossible de tirer votre équipe. Fermez et rouvrez pour réessayer.',
    opensIn: '{{round}} ouvre dans {{time}}.',
    openError: 'Impossible d’ouvrir ce pack. Fermez et réessayez.',
    lockError: 'Impossible de valider ce joueur. Veuillez réessayer.',
    squadDetails: 'Détails de l’équipe',
    homeFixture: 'vs {{club}} {{time}}',
    awayFixture: '@{{club}} {{time}}',
  },
  card: {
    expired: 'Expiré',
    expiredOn: 'Expiré le {{date}}',
    pickYourPlayer: 'Choisissez votre joueur',
    choosePlayer: 'Choisir le joueur',
    revealPlayer: 'Révéler le joueur',
  },
  position: {
    Attacker: 'Attaquant',
    Midfielder: 'Milieu',
    Defender: 'Défenseur',
    Goalkeeper: 'Gardien',
  },
  reveal: {
    title: 'Révélation du jour',
    lockedTitle: 'Joueur validé',
    swipeSub: 'Balayez pour voir les joueurs. Touchez pour sélectionner.',
    selectedSub: 'Joueur sélectionné. Validez pour confirmer.',
    lockedSub: 'Ajouté à votre équipe de la semaine.',
    showPlayer: 'Afficher le joueur {{n}}',
    lockIn: 'Valider le joueur',
    viewSquad: 'Voir mon équipe',
    tapHint: 'Touchez 1 joueur pour le sélectionner',
  },
  sheet: {
    leaderboard: 'Classement',
    weekly: 'Semaine',
    monthly: 'Mois',
    rank: 'Rang',
    user: 'Joueur',
    shots: 'Tirs',
    goals: 'Buts',
    pts: 'Pts',
    you: 'Vous',
    empty: 'Pas encore de participants — le classement se remplit au fil des tirages.',
  },
  info: {
    howToPlay: 'Comment jouer',
    title: 'Comment jouer',
    rules: [
      'Ouvrez un pack de joueur gratuit chaque jour, du lundi au vendredi, pour bâtir votre équipe pour les matchs du week-end.',
      'Chaque pack se débloque à l’heure de révélation prévue — manquez le créneau et l’emplacement expire.',
      'Vos joueurs révélés marquent des points sur les vrais événements de match : {{goal}} pour un but, {{shot}} pour un tir cadré, {{tackle}} pour un tacle et {{interception}} pour une interception.',
      'Les cartes dorées sont plus rares — guettez le traitement doré.',
      'Grimpez au classement — à chaque manche, des prix récompensent plusieurs positions d’arrivée.',
    ],
    logOut: 'Se déconnecter',
    account: 'Compte',
    officialRules: 'Règlement officiel',
    language: 'Langue',
  },
  countdown: {
    day_one: '{{count}} jour',
    day_other: '{{count}} jours',
  },
  prize: {
    ordinal_one: '{{count}}er',
    ordinal_two: '{{count}}e',
    ordinal_few: '{{count}}e',
    ordinal_other: '{{count}}e',
    range: '{{from}} à {{to}}',
  },
};

export default fr;
